import React from 'react';
import { Tabs } from 'antd';
import { Loading } from '@components/common';
import LinkPane from './LinkPane';
import * as CONSTANT from '../../constant';
import styles from './index.less';

const { TabPane } = Tabs;

const SharingContent = ({ isFetching, url, id, hide, cid }) => {
  if (isFetching) {
    return <Loading className={styles.loadingWrapper} />;
  }
  return (
    <div>
      <Tabs defaultActiveKey="link">
        <TabPane tab={CONSTANT.TAB_LINK} key="link">
          <LinkPane url={`${url}/${id}`} hide={hide} cid={cid} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SharingContent;
